<template>
  <v-row dense>
    <v-col class="d-flex child-flex" cols="12">
      <div class="text-center">
        <v-avatar v-if="avatar || !hasUpload" color="primary" size="150">
          <img :src="form.url || `https://ui-avatars.com/api/?name=${name}`" alt="Company avatar" />
        </v-avatar>
        <v-img v-else :src="form.url" contain alt="Company avatar" />

        <p v-if="readonly" class="mt-1 text-subtitle-1">
          {{ label }}
        </p>
        <autoupload-file-input
          v-if="!readonly"
          v-model="form"
          v-bind="$attrs"
          :destroyed="readonly"
          :label="label"
          :url="url"
          @input="$emit('uploadIds', $event)"
          @remove="$emit('removeFile', $event)"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import AutouploadFileInput from '@/modules/_global/_components/AutouploadFileInput';
import formEditable from '@/modules/_global/mixins/form-editable';
import { isEmpty } from 'lodash';
export default {
  name: 'CompanyImage',
  components: { AutouploadFileInput },
  mixins: [formEditable],

  props: {
    label: {
      type: String,
      default: null
    },
    url: {
      type: String,
      required: true
    },
    avatar: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    }
  },

  data() {
    return {};
  },

  computed: {
    hasUpload() {
      return Boolean(this.form) && !isEmpty(this.form);
    }
  }
};
</script>

<style scoped></style>
